export default __webpack_public_path__ + "static/media/pager.c629364f.gif";